/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M8.445 12.668a.9.9 0 1 0-1.303 1.242l2.573 2.745a.9.9 0 0 0 1.335-.036l5.591-7.037a.9.9 0 0 0-1.367-1.17l-4.655 5.913a.4.4 0 0 1-.607.025l-1.567-1.682ZM2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12Z"
})), "0 0 24 24", "CheckCircle");